import { ActionTypes } from "@/actions";

const initialState = {
    loading: false,
    data: [] as any[],
    error: null as any,
};

const componentsReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case ActionTypes.COMPONENTS_REQUEST:
            console.log('🔄 COMPONENTS_REQUEST - Starting component fetch');
            return {
                ...state,
                loading: true,
                error: null
            };
        case ActionTypes.COMPONENTS_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loading: false,
                error: null,
                lastFetchedAt: Date.now()
            };
        case ActionTypes.COMPONENTS_FAILURE:
            console.error('❌ COMPONENTS_FAILURE - Error fetching components:', action.payload);
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case ActionTypes.COMPONENT_UPDATED_IN_LIST:
            const updatedComponent = action.payload;
            const currentData = state.data || [];
            const updatedData = currentData.map((comp: any) =>
                comp.uid === updatedComponent.uid ? updatedComponent : comp
            );
            console.log('🔄 Updating component in list:', {
                updatedComponent,
                updatedData
            });
            return {
                ...state,
                data: updatedData,
            };
        case ActionTypes.LOGOUT:
            return { ...initialState };
        default:
            return state;
    }
}

export default componentsReducer;